import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { IrisDMSFile, IrisDMSFileI } from '../models/IrisDMSFile';
import { setError, setLoaded, setLoading, withRequestState } from '@iris/common/signals/features/request-status.feature';
import { computed, inject } from '@angular/core';
import { IrisFilesService } from '../services/files.service';
import { filter, pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';

export const IrisDmsFileInfoStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState<IrisDMSFileI>(new IrisDMSFile()),
  withRequestState(),
  withComputed(store => ({
    hasAttachments: computed(() => !!store.attachments()?.length),
    fileInfo: computed<Partial<IrisDMSFileI>>(() => ({
      id: store.id(),
      name: store.name(),
      mimeType: store.mimeType(),
      isPreviewReady: store.isPreviewReady(),
      previewId: store.previewId(),
      thumbId: store.thumbId(),
      parentId: store.parentId(),
    })),
    hasDescription: computed(() => !!store.description()),
  })),
  withMethods((
    store,
    filesService = inject(IrisFilesService),
  ) => ({
    fetchFileInfo: rxMethod<string>(
      pipe(
        filter(() => !store.loading()),
        switchMap(fileId => {
          if (store.id() !== fileId) {
            patchState(store, new IrisDMSFile(), setLoading());
          }

          return filesService.getFileById(fileId).pipe(
            tapResponse({
              next: file => patchState(store, new IrisDMSFile(file), setLoaded()),
              error: (err: HttpErrorResponse) => patchState(store, setError(err.message)),
            }),
          );
        }),
      ),
    ),
    updateFileInfo(file: Partial<IrisDMSFileI>): void {
      if (file?.id === store.id()) {
        patchState(store, file);
      }
    },
  })),
);
